export default {
	TYPE: 'type',
	PLACE: 'place',
	PURPOSE: 'purpose',
	PRODUCT_TYPE: 'product_type',
	PRODUCT_PLACE: 'product_place',
	CONSULT_TYPE: 'consult_type',
	CONSULT_PLACE: 'consult_place',
};
